import React from 'react';
import { motion } from 'framer-motion';
import { FiMail, FiMessageCircle, FiArrowRight, FiPhone, FiClock } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-[3rem] p-8 md:p-16 shadow-xl border border-slate-100 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-96 h-96 bg-emerald-50 rounded-full blur-[100px] -mr-48 -mt-48 opacity-50 pointer-events-none" />
          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-6xl font-extrabold text-slate-900 mb-8 leading-tight tracking-tight">
                Let's Grow Your <span className="text-emerald-600">Business</span>
              </h2>
              <p className="text-xl text-slate-500 mb-10 leading-relaxed font-medium">
                Have a project in mind or need help choosing the right solution? We'd love to hear from you. Get in touch today via WhatsApp for the fastest response.
              </p>
              <div className="space-y-6">
                <a href="mailto:digitalgig24@gmail.com" className="group flex items-center p-5 bg-slate-50 rounded-2xl hover:bg-emerald-50 transition-all border border-slate-100 hover:border-emerald-200">
                  <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center text-emerald-600 shadow-sm group-hover:bg-emerald-600 group-hover:text-white transition-all">
                    <SafeIcon icon={FiMail} className="text-xl" />
                  </div>
                  <div className="ml-5">
                    <p className="text-sm font-black text-slate-400 uppercase tracking-widest mb-0.5">Email Us</p>
                    <p className="text-lg font-bold text-slate-900">digitalgig24@gmail.com</p>
                  </div>
                </a>
                <a href="https://go.digitalgigs.eu/chat" target="_blank" rel="noopener noreferrer" className="group flex items-center p-5 bg-slate-50 rounded-2xl hover:bg-emerald-50 transition-all border border-slate-100 hover:border-emerald-200">
                  <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center text-emerald-600 shadow-sm group-hover:bg-emerald-600 group-hover:text-white transition-all">
                    <SafeIcon icon={FiMessageCircle} className="text-xl" />
                  </div>
                  <div className="ml-5">
                    <p className="text-sm font-black text-slate-400 uppercase tracking-widest mb-0.5">WhatsApp</p>
                    <p className="text-lg font-bold text-slate-900">Chat with us</p>
                  </div>
                </a>
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <a href="https://go.digitalgigs.eu/chat" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between p-6 bg-emerald-600 text-white rounded-[2rem] font-bold text-xl hover:bg-emerald-700 transition-all shadow-xl shadow-emerald-600/20 group hover:-translate-y-1 active:scale-95">
                <span>Get a Free Quote</span>
                <SafeIcon icon={FiArrowRight} className="text-2xl group-hover:translate-x-2 transition-transform" />
              </a>
              <a href="https://go.digitalgigs.eu/chat" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between p-6 bg-slate-900 text-white rounded-[2rem] font-bold text-xl hover:bg-slate-800 transition-all shadow-xl shadow-slate-900/10 group hover:-translate-y-1 active:scale-95">
                <span>Book Discovery Call</span>
                <SafeIcon icon={FiPhone} className="text-2xl group-hover:rotate-12 transition-transform" />
              </a>
              <a href="https://go.digitalgigs.eu/chat" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between p-6 bg-white text-slate-900 border-2 border-slate-100 rounded-[2rem] font-bold text-xl hover:border-emerald-600 hover:text-emerald-600 transition-all group hover:-translate-y-1 active:scale-95">
                <span>Chat on WhatsApp</span>
                <SafeIcon icon={FiMessageCircle} className="text-2xl group-hover:scale-110 transition-transform" />
              </a>
              <div className="flex items-center justify-center mt-4 text-slate-400 font-bold text-sm bg-slate-50 py-3.5 rounded-[1.25rem] border border-slate-100">
                <SafeIcon icon={FiClock} className="mr-2.5 text-emerald-500 text-base" />
                Response Time:
                <span className="text-slate-700 ml-1.5">Usually within 24 hours</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
